import type { FaireProductEntity } from "../../entity_types/product";

export const p_pucppp276r: FaireProductEntity = {
  token: "p_pucppp276r",
  type: "product",
  name: "LE LIS MYSTERY BOX - 100 ASSORTED STYLES",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/c03ad33ad96b1fdf1522d43fe517d9e3cc13e9ec2f5e8063429c3de645058c71.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description:
    "100 PIECES OF ASSORTED LE LIS STYLES! \n\nPLEASE DO NOT MISS THIS OPPORTUNITY TO ATTAIN OUR LINE AT $5 A PIECE! \n\nALL STYLES ARE BRAND NEW AND NOT DAMAGED! PIECES COME FROM BROKEN PACKS!\n\nBOX CONTAINS ASSORTED STYLES FROM TOPS, BOTTOMS, DRESSES, OUTERWEAR, AND SETS.\n\nBOX CONTAINS ASSORTED SIZES RANGING FROM SMALL, MEDIUM, LARGE, SMALL/MEDIUM, MEDIUM/LARGE, ONE SIZE\n\nNO RETURNS OR REFUNDS!\nALL SALES ARE FINAL!\n\nPLEASE NOTE: PROCESSING TIME TAKES 7-10 BUSINESS DAYS",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:20.329Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
